module.exports = __webpack_public_path__ + "media/images/global/icons/fan-982869c5a4450c17b676c6f9c44eeaed.svg";